import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'

const Layout = ({ children, user, profile, onLogout }) => {
  const location = useLocation()
  const [showDropdown, setShowDropdown] = useState(false)

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">
          <h1 className="text-2xl font-bold text-green-600">SafeNav</h1>
          <nav className="flex space-x-4">
            <Link to="/" className={`px-3 py-2 rounded ${location.pathname === '/' ? 'bg-green-100 text-green-700' : 'text-gray-600'}`}>Dashboard</Link>
            <Link to="/trips" className={`px-3 py-2 rounded ${location.pathname === '/trips' ? 'bg-green-100 text-green-700' : 'text-gray-600'}`}>Trip History</Link>
            <Link to="/profile" className={`px-3 py-2 rounded ${location.pathname === '/profile' ? 'bg-green-100 text-green-700' : 'text-gray-600'}`}>Profile</Link>
          </nav>
          <div className="relative">
            <button onClick={() => setShowDropdown(!showDropdown)} className="flex items-center space-x-2">
              <span>{profile?.username || user?.email?.split('@')[0]}</span>
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>
            {showDropdown && (
              <div className="absolute right-0 mt-2 w-48 bg-white rounded shadow-lg py-1 z-50">
                <Link to="/profile" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">Profile</Link>
                <button onClick={onLogout} className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">Logout</button>
              </div>
            )}
          </div>
        </div>
      </header>
      <main className="max-w-7xl mx-auto py-6 px-4">{children}</main>
    </div>
  )
}

export default Layout